export enum ButtonGroupSpacing {
  s = 's',
  m = 'm',
  normal = 'normal',
}
